import { Maybe, MProperty } from "~/operations";
import { CheckQueriesPropertyItem } from "~/pages/space/security/components/Check/CheckQueries/components/CheckQueriesPropertyItem";

interface Props {
  properties: MProperty[] | Maybe<MProperty>[] | null | undefined;
}

export function CheckQueriesPropertyItems({ properties }: Props) {
  return (
    <>
      {properties?.map((property, key) => {
        if (!property) return;

        const { uid, mql, __typename } = property;

        return (
          <CheckQueriesPropertyItem
            key={key}
            uid={uid}
            mql={mql}
            type={__typename}
          />
        );
      })}
    </>
  );
}
